import React from 'react'


export default function Home(){
    return(
        <div>

          
            <div className='home' id="home">
                <h1>Building Awesome<br/>
                Things with code!
                </h1>
                <button className='blackbtn'>Explore</button>
            </div>
            </div>       
  
    )
}